/**
 * 模組代碼 : -
 * 模組說明 : (共用模組) 提供共用功能元件及函式
 * @module web/components/CommonComponent
 */

// ----- import from npm modules -----
import $ from 'jquery';
import 'datatables.net-bs5'; // 引入 DataTables Bootstrap 5 样式
import DataTable from 'datatables.net-dt';

// ----- constants -----
const PAGE_LENGTH = 20;

$.fn.dataTable.ext.oSort['natural-asc'] = function (a, b) {
  a = a
    .toString()
    .replace(/<i.*?>.*?<\/i>/g, '')
    .replace('樓', '');
  b = b
    .toString()
    .replace(/<i.*?>.*?<\/i>/g, '')
    .replace('樓', '');

  if (/^\d+$/.test(a) && /^\d+$/.test(b)) {
    return parseInt(a, 10) - parseInt(b, 10);
  }

  if (/^[a-zA-Z]+\d+$/.test(a) && /^[a-zA-Z]+\d+$/.test(b)) {
    const aLetter = a.match(/[a-zA-Z]+/)[0];
    const bLetter = b.match(/[a-zA-Z]+/)[0];

    if (a < b) return 1;
    if (a > b) return -1;
    if (aLetter < bLetter) return 1;
    if (aLetter > bLetter) return -1;

    const aNumber = parseInt(a.match(/\d+/)[0], 10);
    const bNumber = parseInt(b.match(/\d+/)[0], 10);
    return aNumber - bNumber;
  }

  if (/^\d+$/.test(a) && /^[a-zA-Z]+\d+$/.test(b)) return 1;
  if (/^[a-zA-Z]+\d+$/.test(a) && /^\d+$/.test(b)) return -1;

  return a.localeCompare(b);
};

$.fn.dataTable.ext.oSort['natural-desc'] = function (a, b) {
  a = a
    .toString()
    .replace(/<i.*?>.*?<\/i>/g, '')
    .replace('樓', '');
  b = b
    .toString()
    .replace(/<i.*?>.*?<\/i>/g, '')
    .replace('樓', '');

  const aIsNumber = /^\d+$/.test(a);
  const bIsNumber = /^\d+$/.test(b);

  if (aIsNumber && bIsNumber) {
    return parseInt(b, 10) - parseInt(a, 10);
  }

  if (aIsNumber) return -1;
  if (bIsNumber) return 1;

  if (a < b) return -1;
  if (a > b) return 1;

  return 0;
};

/**
 * 說明：透過 DataTables 套件，將資料以表格方式呈現
 * @param {*} tableSelector
 * @param {*} dataSet
 * @param {*} columnConfig
 * @param {*} orderConfig
 * @param {*} fixedColumnsConfig
 * @param {*} bPaginate 是否啟用分頁
 * @param {*} bScrollX 是否啟用水平捲軸
 * @param {*} bServerSide 是否啟用 server-side 處理
 * @param {*} serverCallback server-side 回調函式 (data, callback, settings) => {}
 */
export function DataTableComponent(
  tableSelector,
  dataSet,
  columnConfig,
  orderConfig,
  fixedColumnsConfig,
  bPaginate = false,
  bScrollX = false,
  bServerSide = false,
  ajax = null,
) {
  // 配置基礎選項
  const config = {
    retrieve: true,
    language: {
      info: '共 _TOTAL_ 筆資料',
      infoEmpty: '沒有資料',
      loadingRecords: '資料載入中...',
      processing:
        '<div class="rbt-loader spinner-border spinner-border-md" ></div><div>資料載入中...</div>',
      lengthMenu: '每頁顯示 _MENU_ 筆資料',
      zeroRecords: '找不到資料',
    },
    processing: true,
    dom: 'rt<"dt-bottom" <"dt-info"i><"dt-paging"p>>',
    searching: false,
    lengthMenu: [20, 50, 100],
    select: true,
    paging: bPaginate,
    pageLength: PAGE_LENGTH,
    responsive: true,
    scrollCollapse: true,
    scrollY: '45vh',
    scrollX: bScrollX,
    fixedColumns: fixedColumnsConfig,
    columns: columnConfig,
    order: orderConfig,
    className: 'dt-bootstrap5',
  };

  // Server-side 配置
  if (bServerSide && ajax) {
    config.serverSide = true;
    config.ajax = ajax;
    delete config.data;
  } else {
    // Client-side：正常傳入資料
    config.data = dataSet;
  }

  return new DataTable(tableSelector, config);
}

/**
 * 說明：批次控制功能
 */
export function batchCheckControls() {
  /**
   *
   */
  function updateCheckAllAndButtonState() {
    const allCheckboxes = $('input[name="cks"]');
    const checkedCheckboxes = allCheckboxes.filter(':checked');

    const totalCheckboxes = allCheckboxes.length;
    const totalChecked = checkedCheckboxes.length;

    if (totalChecked === 0) {
      $('#check-all').prop('checked', false);
      $('#check-all').prop('indeterminate', false);
    } else if (totalChecked === totalCheckboxes) {
      $('#check-all').prop('checked', true);
      $('#check-all').prop('indeterminate', false);
    } else {
      $('#check-all').prop('checked', false);
      $('#check-all').prop('indeterminate', true);
    }

    $('.btn-batch').prop('disabled', totalChecked === 0);

    $('#checked-count-display').text('( ' + totalChecked + ' )');
  }

  $('#check-all').on('change', function () {
    const isChecked = $(this).is(':checked');
    $('input[name="cks"]').prop('checked', isChecked);
    updateCheckAllAndButtonState();
  });

  $(document).on('change', 'input[name="cks"]', function () {
    updateCheckAllAndButtonState();
  });

  updateCheckAllAndButtonState();
}
